import React from 'react';
import Grid from '@mui/material/Grid';
import Rectangle from '../images/Rectangle 138.png';
import Profile from '../images/Ellipse 25.png';
import { ArrowForwardIos } from '@mui/icons-material';
function createinsights() {
    return (
        <div className="bginsight">
            <Grid container spacing={1}>
                <Grid item md={6}>
                    <div className="inblogre">
                        <p className="inblog">Blogs</p>
                        <p className="inlatest">Latest Insights From PPLACD</p>
                        <p className="intext">Pellentesque etiam blandit in tincidunt at donec. </p>
                        <div className="inbgblog">
                            <div className="insiblog">
                                <p className="fisrtblog">Tips and Trick</p>
                                <p className="secondblog">Create Amazing Resume</p>
                                <p className="thirdblog">Decorating with neutrals brings balance to the dining room..</p>
                                <p className="forthblog"><button className="inbtn" type="button">Read More <ArrowForwardIos sx={{fontSize:'16px'}}/></button></p>
                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid item md={6}>
                    <div className="rowinbg">
                        <img className="hiinbg" src={Rectangle} alt="Socailmedia" />
                        <div className="inflexcol">
                            <p className="bgtips">Tips and Tricks</p>
                            <p className="bg2">Lorem Ipsum Dolor Sit
                                Amet</p>
                            <p className="intext">Pellentesque etiam blandit in...</p>
                            <div className="bgrowflex">
                                <p>
                                    <img className="bgpro" src={Profile} alt="Socailmedia" />
                                </p>
                                <p className="sidebg">
                                By Jerremy Jean
                                </p>
                                <p className="bgdate">Friday, 1 April 2022</p>
                            </div>
                        </div>
                    </div>
                    <div className="rowinbg">
                        <img className="hiinbg" src={Rectangle} alt="Socailmedia" />
                        <div className="inflexcol">
                            <p className="bgtips">Tips and Tricks</p>
                            <p className="bg2">Lorem Ipsum Dolor Sit
                                Amet</p>
                            <p className="intext">Pellentesque etiam blandit in...</p>
                            <div className="bgrowflex">
                                <p>
                                    <img className="bgpro" src={Profile} alt="Socailmedia" />
                                </p>
                                <p className="sidebg">
                                By Jerremy Jean
                                </p>
                                <p className="bgdate">Friday, 1 April 2022</p>
                            </div>
                        </div>
                    </div>
                    <div className="rowinbg">
                        <img className="hiinbg" src={Rectangle} alt="Socailmedia" />
                        <div className="inflexcol">
                            <p className="bgtips">Tips and Tricks</p>
                            <p className="bg2">Lorem Ipsum Dolor Sit
                                Amet</p>
                            <p className="intext">Pellentesque etiam blandit in...</p>
                            <div className="bgrowflex">
                                <p>
                                    <img className="bgpro" src={Profile} alt="Socailmedia" />
                                </p>
                                <p className="sidebg">
                                By Jerremy Jean
                                </p>
                                <p className="bgdate">Friday, 1 April 2022</p>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <div className="flexbgbtn">
            <button className="bgbtn" type="button">View More <ArrowForwardIos sx={{fontSize:'16px'}}/> </button>
            </div>
        </div>
    );
}

export default createinsights;